import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top-button"
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-40 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[hsl(var(--primary))] text-white shadow-[0_18px_50px_rgba(15,23,42,0.25)] hover:bg-[hsl(var(--tbs-navy-800))] ring-2 ring-[hsl(var(--accent))]/40"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default BackToTop;
